import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import PortalBannerItem from './PortalBannerItem';

export default class PortalBanner extends Component {
  render () {
    const { event, isInnerType } = this.props;

    if (isEmpty(event) && !event.get('bannerOfOff')) {
      return null;
    }
    return (
      <PortalBannerItem event={event} isInnerType={isInnerType} />
    );
  }
}

PortalBanner.propTypes = {
  event: PropTypes.object.isRequired,
  isInnerType: PropTypes.bool
};

PortalBanner.defaultProps = {
  isInnerType: false
}


// WEBPACK FOOTER //
// ./src/components/PortalBanner/index.js